import { memo } from 'react';

import { Button } from './Button';
import { ButtonProps } from './types';

export const SubmitButton = memo((props: Omit<ButtonProps, 'type'>) => (
  <Button htmlType="submit" {...props} />
));
SubmitButton.displayName = 'SubmitButton';
